var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2451_64037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.219144 8.72623C0.0784452 8.57808 -3.33543e-07 8.38155 -3.24612e-07 8.17723C-3.15681e-07 7.97291 0.0784452 7.77639 0.219144 7.62823L6.41714 1.20598C6.55377 1.06222 6.7182 0.947755 6.90045 0.869534C7.08269 0.791314 7.27894 0.750977 7.47727 0.750977C7.67559 0.750977 7.87184 0.791314 8.05409 0.869534C8.23634 0.947755 8.40077 1.06222 8.53739 1.20598L14.7811 7.67473C15.0699 7.97473 15.0736 8.46073 14.7886 8.76523C14.7207 8.83895 14.6384 8.89793 14.5468 8.9385C14.4551 8.97907 14.3561 9.00037 14.2559 9.00107C14.1557 9.00178 14.0564 8.98187 13.9642 8.94259C13.872 8.90331 13.7888 8.84549 13.7199 8.77273L8.00714 2.85298C7.93883 2.78105 7.85659 2.72376 7.76543 2.68462C7.67427 2.64547 7.5761 2.62528 7.47689 2.62528C7.37769 2.62528 7.27952 2.64547 7.18836 2.68462C7.0972 2.72376 7.01496 2.78105 6.94664 2.85298L1.27889 8.72548C1.21064 8.7974 1.12847 8.85467 1.03737 8.89381C0.946275 8.93295 0.848166 8.95313 0.749019 8.95313C0.649871 8.95313 0.551762 8.93295 0.460666 8.89381C0.369569 8.85467 0.287394 8.79815 0.219144 8.72623Z",
    fill: "#252730"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_64037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.25,
    height: 15,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.65d891d4eabf9cd8f91731abb2cc00c8.svg";
export { ForwardRef as ReactComponent };